export const addApiUrlToLocalStorage = () => {
	localStorage.setItem("backEnd", "https://protika.ir/protikaBackEnd");
};

export const prefixUrl = () => {
	if (
		localStorage.getItem("backEnd") === null ||
		localStorage.getItem("backEnd") === undefined
	) {
		addApiUrlToLocalStorage();
	}
	return localStorage.getItem("backEnd");
};
